$(document).ready(function () {

    let recentlyViewed = localStorage.getItem('recentlyViewed');
    const fetchedProductsIds = [];
    if (!recentlyViewed) {
        recentlyViewed = [];
        recommended_collections[0].recommended_collection_handle.forEach((item) => {
            let re_collection = {
                'collection': item,
                'cursor': null
            }
            recentlyViewed.push(re_collection)
        });
        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    }
    else {
        recentlyViewed = JSON.parse(recentlyViewed);
    }

    // Retrieve the product details array from local storage
    var currentProducts = localStorage.getItem('currentProducts');
    var productArray = JSON.parse(currentProducts) || []; // Initialize as an empty array if not found

    // Loop through the productArray and access each product's details
    var recent_viewed_products = '';
    productArray.forEach(function (productDetails, index) {
        fetchedProductsIds.push('gid://shopify/Product/'+productDetails.productId);
        var productName = productDetails.productName;
        var productPrice = productDetails.productPrice;
        var productImage = productDetails.productImage;
        var productUrl = productDetails.productUrl;
        var productComparePrice = productDetails.productComparePrice;

        if (typeof productComparePrice !== 'undefined') {

            var price1 = parseFloat(productComparePrice.replace(/[^0-9.-]+/g, ''));
            var price2 = parseFloat(productPrice.replace(/[^0-9.-]+/g, ''));
            // Calculate the percentage difference
            var percentageDifference = ((price1 - price2) / price1) * 100;
            var comparePrice = `<div class="price  price--on-sale ">
                                    <div class="price__container">
                                        <div class="price__sale">
                                            <span class="price-item price-item--sale price-item--last">${productPrice}</span>
                                            <span class="discount-price">
                                                <s class="price-item price-item--regular">${productComparePrice}</s>
                                            </span>
                                        </div>
                                    <span class="offer-percentage">${percentageDifference.toFixed(0)}% OFF</span></div></div>`;
        } else {
            comparePrice = `<div class="price ">
                                <div class="price__container">
                                    <div class="price__regular">
                                        <span class="price-item price-item--regular">${productPrice}</span>
                                    </div>
                                </div>
                            </div>`;
        }
        recent_viewed_products += `<div class="product-grid recommended-product-grid">
                                        <a href="${productUrl}">
                                            <div class="prdct-grid-bg prdct-slide-bg">
                                                <div class="prdct-img-contnr">
                                                    <img src="${productImage}">
                                                </div>
                                                <div class="inr-cntnt">
                                                    <p>${productName}</p>
                                                    ${comparePrice}
                                                </div>
                                            </div>
                                        </a>
                                    </div>`;
    });

    let isFirst = true;

        $("#loadMoreButton").hide();
        let isLoadingMore = false;

        var scrollCount = 0;
        var maxScrollsToShowButton = 3;
        var maxScrollsToShowButtonAppend = 3;

        $(window).scroll(function () {
            if (scrollCount < maxScrollsToShowButton) {
                recentlyViewed.length && loadMoreProducts();
            }
        });

        function loadMoreProducts() {
            if (isLoadingMore) {
                return; // Stop making AJAX calls if already loading
            }

            var footer = $('footer');
            var distanceThreshold = 3000;
            var windowHeight = $(window).height();
            var footerTop = footer.offset().top;
            var scrollDistance = $(window).scrollTop();
            var distanceToFooter = footerTop - (scrollDistance + windowHeight);

            if (distanceToFooter < distanceThreshold) {
                
                recentlyViewed.length && fetchProdcutsData().then(function(productData) {
                  
                    if (!productData || !productData.product_data) {
                        $("#loadMoreButton").hide();
                        return null;
                    }
                    
                    if (isFirst == true) {
                        $("#recommended_by_recent_view").append(recent_viewed_products);
                    }
    
                    isFirst = false;
                    const jsonData = productData.product_data;
                    const shopCurrencyCode = productData.currency_code;
                    jsonData.forEach(function(product){
                        let productHTML =  generateProductCard(product, shopCurrencyCode)
                        $("#recommended_by_recent_view").append(productHTML);
                    });
                    
                    scrollCount++;
                    if (scrollCount >= maxScrollsToShowButton) {
                        append_load_products();// fill remaining spaces
                        $("#loadMoreButton").show();
                    }

                  }).catch(function(error) { });
            }
        }

        const fetchProdcutsData = ()=> {
            return new Promise((resolve, reject) => {
                let url = "https://api.zaappy.com/api/recommended-product-v2.php";
                $.ajax({
                  type: "POST",
                  url: url,
                  data: {
                    "collection_handle": recentlyViewed
                  },
                  beforeSend: function () {
                    isLoadingMore = true;
                    append_load_shimmer();
                  },
                  success: function (response) {

                    if(!response){
                        $("#recommended_by_recent_view .recommended-product-grid.shimmer").remove();
                        $("#loadMoreButtonWrapper").hide();
                        resolve({
                            "currency_code": "AED",
                            "product_data": [],
                            "collection_array": []
                        });
                        return false;
                    }

                    isLoadingMore = false;
                    const response_output = $.parseJSON(response);
                     if (response_output.product_data.length == 0){
                      $("#loadMoreButtonWrapper").hide();
                     }
                    recentlyViewed = response_output.collection_array.map(function(item) {
                        item.collection = item.collection.substring(1);
                        let collection = item.collection.replace(/_/g, "-");
                        return { ...item, collection: collection };
                    });

                    $("#recommended_by_recent_view .recommended-product-grid.shimmer").remove();
                    resolve(response_output);
                  },
                  error: function (jqXHR, exception) {
                    console.log(jqXHR);
                    reject(jqXHR); // Reject the promise on error
                  }
                });
              });
        }

        function loadMoreAfterButtonClick() {

            if (isLoadingMore || scrollCount < maxScrollsToShowButton) {
                return; // Wait for 3 scrolls before allowing more loads
            }
            $("#loadMoreButton").hide();
            loadMoreProducts();
            $(".recommended-load-btn").text('Load More');
            maxScrollsToShowButton = maxScrollsToShowButton + maxScrollsToShowButtonAppend;
           
        }

        $("#loadMoreButton").click(function () {
            loadMoreAfterButtonClick(); // Call the loadMoreAfterButtonClick function when the button is clicked
        });

        const append_load_shimmer = () => {
            const count = $('#recommended_by_recent_view .recommended-product-grid').length;
            let remains = 0;
            let card_per_row = 5;
            const window_width = $(window).width();
            if (window_width < 992) {
                card_per_row = 2
            }
            else if (window_width < 1024) {
                card_per_row = 3
            }
            else if (window_width < 1400) {
                card_per_row = 4
            }

            if ((count % card_per_row)) {
                remains = card_per_row - (count % card_per_row);
            }

            const html = '<div class="product-grid recommended-product-grid shimmer"><div class="shimmer-card"><div class="shimmer-card-img"><div class="shimmer animate-shimmer"></div></div><div class="shimmer-card-details"><div class="card-rate"><div class="card-rate-shimmer animate-shimmer"></div></div><div class="card-star"><div class="card-star-shimmer animate-shimmer"></div></div><div class="card-data"><div class="card-data-shimmer animate-shimmer"></div></div><div class="card-content"><div class="card-content-shimmer animate-shimmer"></div></div></div></div></div>';

            for (let i = 0; i < remains + card_per_row; i++) {
                $("#recommended_by_recent_view").append(html);
            }

        }

        function append_load_products() {

            if (isLoadingMore) {
                return; // Stop making AJAX calls if already loading
            }
         
            const count = $('#recommended_by_recent_view .recommended-product-grid').length;
            let card_per_row = 5;
            const window_width = $(window).width();

            if (window_width < 992) {
                card_per_row = 2;
            } else if (window_width < 1024) {
                card_per_row = 3;
            } else if (window_width < 1400) {
                card_per_row = 4;
            }
          
            const startIndex = count % card_per_row; // Determine the index to start appending from
            if(startIndex == 0){
              return ;
            }
            let remains = card_per_row - startIndex;
            if (remains > 0) {
                // Load more products using AJAX
                fetchProdcutsData().then(function(productData) {
                    if (!productData.product_data) {
                        return;
                    }
                    const jsonData = productData.product_data;
                    const shopCurrencyCode = productData.currency_code;
                    
                    jsonData.forEach(function(product){
                        if(remains <= 0 ) {
                            return;
                        }
                        let productCard = generateProductCard(product, shopCurrencyCode);
                        if(productCard){
                           $("#recommended_by_recent_view").append(productCard);
                          remains --;
                        }
                    });
                    isLoadingMore = false; // Set isLoadingMore to false when the request is complete
                })
            }
        }

        const generateProductCard = (product, shopCurrencyCode)=>{

                if (fetchedProductsIds.includes(product.id)) {
                    return '';
                } else {
                    fetchedProductsIds.push(product.id);
                }
          
                const productTitle = product.title;
                const productId = product.id;
                const productID = productId.match(/\/(\d+)$/);

                const productPrice = product.variants.edges[0].node.price;
                const productComparePrice = product.variants.edges[0].node.compareAtPrice;
                const productImage = product.images.edges[0].node.originalSrc;
                const productURL = product.onlineStoreUrl;
                let priceData = '';
                let percentageOff = '';

                // Check if productURL is null or empty
                if (productURL == null || productURL === '') {
                    return ''; // Skip this product
                }

                if (productComparePrice == null || productComparePrice === '') {
                    priceData = `<div class="price__sale">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--sale price-item--last">${productPrice} ${shopCurrencyCode}</span>
                            </div>`;
                } else {
                    percentageOff = ((productComparePrice - productPrice) / productComparePrice) * 100;
                    const formattedPercentageOff = percentageOff.toFixed(0);
                    const percentageOffString = `${formattedPercentageOff}% OFF`;

                    priceData = `<div class="price__sale">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--sale price-item--last">${productPrice} ${shopCurrencyCode}</span>
                                <span class="discount-price">
                                    <s class="price-item price-item--regular">${productComparePrice} ${shopCurrencyCode}</s>
                                </span>
                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                            </div>
                            <span class="offer-percentage">${percentageOffString}</span>`;
                }

                let productHTML = `<div class="product-grid recommended-product-grid">
                                    <a href="${productURL}">
                                    <div class="prdct-grid-bg prdct-slide-bg">
                                        <div class="prdct-img-contnr"><img src="${productImage}">
                                        </div>
                                        <div class="inr-cntnt">
                                            <p>${productTitle}</p>
                                            <div class="price  price--on-sale ">
                                                        <div class="price__container">
                                                            ${priceData}
                                                        </div>
                                                    </div>
                                            <div class="hm-rw">
                                                <div class="enorm-shopify-product-reviews" data-id="${productID[1]}"></div>
                                            </div>
                                            <div class="htusb-placeholder-countdown"></div>
                                        </div>
                                    </div>
                                    </a>
                                </div>`;

            return productHTML;
        }

});